export type AuthMode = 'clerk' | 'local-mock-jwt' | 'aws-cognito' | 'unconfigured';

/** Runtime auth mode from inlined CRA env vars (priority: Clerk → dev JWT → Cognito). */
export function getAuthMode(): AuthMode {
  const clerkKey = (process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '').trim();
  if (clerkKey) {
    return 'clerk';
  }

  const devJwt = (process.env.REACT_APP_DEV_JWT || '').trim();
  if (devJwt) {
    return 'local-mock-jwt';
  }

  const pool = (process.env.REACT_APP_AUTH_USER_POOL_ID || '').trim();
  if (pool) {
    return 'aws-cognito';
  }

  return 'unconfigured';
}

export function isClerkAuthEnabled(): boolean {
  return getAuthMode() === 'clerk';
}
